import type { HTMLAttributes, ReactNode } from "react";
import { cx } from "@/lib/cx";

export type EyebrowProps = HTMLAttributes<HTMLDivElement> & {
  children?: ReactNode;
  /** The rotating red asterisk. The only looping animation on the page. */
  marker?: boolean;
  index?: string;
};

export function Eyebrow({ children, marker = true, index, className, ...rest }: EyebrowProps) {
  return (
    <div className={cx("flex items-center gap-2", className)} {...rest}>
      {marker && (
        <span aria-hidden="true" className="inline-block text-signal-500 text-[16px] leading-[1] animate-spin-slow">
          ✱
        </span>
      )}
      {index != null && <span className="font-label text-label text-text-faint">{index}</span>}
      <span className="font-label text-label uppercase text-text-muted">{children}</span>
    </div>
  );
}
